import {css} from 'lit';
export const styles = css`:host(:not([vertical])){border-top:1px solid #ced4da;display:block;width:100%}:host([vertical]){border-left:1px solid #ced4da;display:inline-block;height:100%}`;
export default styles;
